"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _Blockchains = require("./Blockchains"),
    Token = /*#__PURE__*/function () {
  function a() {
    var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : _Blockchains.Blockchains.EOS,
        c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "",
        d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "",
        e = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null,
        f = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : null;
    (0, _classCallCheck2["default"])(this, a), this.blockchain = b, this.contract = c, this.symbol = d, this.name = e ? e : d, this.decimals = f;
  }

  return (0, _createClass2["default"])(a, null, [{
    key: "placeholder",
    value: function placeholder() {
      return new a();
    }
  }, {
    key: "fromJson",
    value: function fromJson(a) {
      return Object.assign(this.placeholder(), a);
    }
  }]), a;
}();

exports["default"] = Token;